<template>
  <div>
    <div class="mb-4">
      <h3>Identificação</h3>

      <b-row>
        <b-col cols="6">
          <base-input
            label="Código:"
            :show-warning="revisao('codigo')"
            invalid-feedback="Código é um campo obrigatório."
          >
            <b-form-input
              v-model="oportunidade.codigo"
              placeholder="Código"
              :state="validateState('codigo')"
            />
          </base-input>
        </b-col>

        <b-col cols="12">
          <base-input
            label="Nome:"
            :show-warning="revisao('nome_programa')"
          >
            <b-form-input
              v-model="oportunidade.nome"
              placeholder="Nome"
              :state="validateState('nome')"
            />
          </base-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <base-input
            label="Objeto:"
            :show-warning="revisao('categorias_do_programa')"
          >
            <Editor v-model="oportunidade.objeto" />
          </base-input>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <h3>Descrição Principal</h3>
      <b-row>
        <b-col>
          <base-input
            label="Descrição:"
            :show-warning="revisao('descricao')"
          >
            <Editor v-model="oportunidade.descricao" />
          </base-input>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <h3>Logo/Tipo Imagem</h3>
      <b-row>
        <b-col>
          <b-form-group label="Imagem">
            <Arquivo v-model="oportunidade.imagem" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <h3>Tipo de Instrumento</h3>

      <b-row>
        <b-col>
          <base-input
            label="Tipo de Instrumento:"
            :show-warning="revisao('tipo_instrumento')"
          >
            <SelectTipoInstrumento v-model="oportunidade.tipo_instrumento_id" />
          </base-input>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <h3>Categoria</h3>

      <b-row>
        <b-col>
          <b-form-group label="Categoria:">
            <SelectCategorias v-model="oportunidade.categorias" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="mb-4">
      <h3>Qualificação da Proposta</h3>

      <b-form-group>
        <b-form-checkbox
          name="qualificacao_proposta_checkbox"
          v-model="oportunidade.qualificacao_propostas"
          v-for="(proposta, key) in qualificacao_proposta"
          :key="key"
          :value="proposta.value"
          stacked
        >
          {{ proposta.text }}

          <div
            v-if="proposta.children && propostaSelecionada(proposta.value)"
            class="my-4"
          >
            <h4>{{ proposta.children_text }}</h4>
            <b-form-radio-group
              name="qualificacao_proposta_radio"
              v-model="oportunidade.qualificacao_propostas_emenda"
              :options="proposta.children"
              stacked
            />
          </div>
        </b-form-checkbox>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Form/Editor";
import SelectConcedente from "@/modules/concedentes/Components/SelectConcedente";
import SelectCategorias from "@/modules/categorias/Components/SelectCategorias";
import SelectTipoInstrumento from "@/modules/oportunidades/Components/SelectTipoInstrumento";
import Arquivo from "@/modules/files/Components/Arquivo.vue";
import BaseInput from "./BaseInput.vue";
import { validationMixin } from "vuelidate";
import { required, minLength, decimal } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

export default {
  mixins: [validationMixin],
  components: {
    Editor,
    Arquivo,
    BaseInput,
    SelectConcedente,
    SelectCategorias,
    SelectTipoInstrumento,
  },
  data: () => ({
    plataformas: [],
  }),
  validations: {
    oportunidade: {
      nome: {
        required,
        minLength: minLength(3),
      },
      codigo: {},
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
    ...mapGetters("oportunidades", ["qualificacao_proposta"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    checkFirstOption() {
      this.oportunidade.qualificacao_propostas.includes("emenda-parlamentar")
        ? (this.showModalidadeEmenda = true)
        : (this.showModalidadeEmenda = false);
    },
    propostaSelecionada(value) {
      return this.oportunidade.qualificacao_propostas?.indexOf(value) >= 0;
    },
    revisao(campo) {
      if (!this.oportunidade || !this.oportunidade.campos_revisao) return false;
      return this.oportunidade.campos_revisao.some(
        (item) => item.campo === campo
      );
    },
  },
  watch: {
    "oportunidade.imagem": {
      deep: true,
      handler: function (imagem) {
        this.oportunidade.imagem_id = imagem ? imagem.id : null;
      },
    },
  },
  created() {},
};
</script>

<style></style>
